module.exports = __webpack_public_path__ + "static/media/25.26ee8808.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/25.jpg
// module id = 586
// module chunks = 0